module.exports = __webpack_public_path__ + "bj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bj.svg
// module id = 452
// module chunks = 0